import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Ticker({
  feed,
  title,
  position='bottom',
  backgroundColor='rgba(255,255,255,0)',
}) {
  const reducer = (currentIndex) => (currentIndex >= feed.length - 1 ? 0 : currentIndex + 1);

  const [index, setIndex] = useReducer(reducer, 0);

  useEffect(() => {
    const intervalId = setInterval(setIndex, 5000);
    return () => clearInterval(intervalId);
  }, []);

  // const link = ({
  //   href,
  //   children,
  // }) => (
  //     <a
  //       href={href}
  //       target="_blank"
  //       rel="noopener noreferrer"
  //     >
  //       {children}
  //     </a>
  //   );
  if (feed.length) {
    return (
      <div
        className="news-feed"
        style={{
          top: (position === 'top') ? 0 : undefined,
          backgroundColor,
        }}
      >
        <span
          className="news-feed-inner"
          style={{ fontSize: '14px' }}
        >
          <strong className="news-feed-label">
            <FontAwesomeIcon icon={['fal', 'comment-alt-lines']} />
            {title}
          </strong>
          <ReactMarkdown>{feed[index]}</ReactMarkdown>
        </span>
      </div>
    );
  }

  return '';
}

Ticker.propTypes = {
  feed: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  position: PropTypes.string,
  backgroundColor: PropTypes.string,
};

